import { t } from 'i18next';
import { GridFlex, Text, Field } from '@stigg-components';
import { SelectProps } from '../../../../components/Select';
import * as Yup from 'yup';
import { AccountAccessMethod } from '@stigg-types/apiTypes';
import { TooltipFields } from 'src/components/InformationTooltip';

export function getAccessMethodField<FormValues>({
  withLabels = false,
  disabledMap,
  disabled = false,
  tooltip,
}: {
  disabled?: boolean;
  withLabels?: boolean;
  disabledMap?: Record<AccountAccessMethod, boolean>;
  tooltip?: TooltipFields;
}): Field<FormValues> {
  const menuProps: Partial<SelectProps> = {
    menuMinWidth: 550,
    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
    transformOrigin: { horizontal: 'left', vertical: 'top' },
  };

  const i18nAccessMethodPrefix = 'accounts.loginOptions.accessMethod.options';

  return {
    type: 'select',
    id: 'accessMethod',
    disabled,
    tooltip,
    restProps: {
      ...menuProps,
    },
    label: withLabels ? t('accounts.loginOptions.accessMethod.fieldLabel') : undefined,
    placeholder: t('accounts.accountRolePlaceholder'), //
    values: [AccountAccessMethod.InviteOnly, AccountAccessMethod.AuthorizedDomain, AccountAccessMethod.Sso].map(
      (loginOption) => ({
        value: loginOption,
        disabled: disabledMap?.[loginOption],
        overrideDisplayValue: (
          <GridFlex.RowCenter columnGap={2}>
            <Text.B2 color="primary">{t(`${i18nAccessMethodPrefix}.${loginOption}.title`)}</Text.B2>
          </GridFlex.RowCenter>
        ),
        displayValue: (
          <GridFlex.RowCenter columnGap={2}>
            <GridFlex.Column>
              <Text.B1 color="primary">
                {t(
                  `${i18nAccessMethodPrefix}.${loginOption}.${disabledMap?.[loginOption] ? 'unauthorizedAccessTitle' : 'title'}`,
                )}
              </Text.B1>
              <Text.B2 color="secondary" sx={{ textWrap: 'auto' }}>
                {t(`${i18nAccessMethodPrefix}.${loginOption}.description`)}
              </Text.B2>
            </GridFlex.Column>
          </GridFlex.RowCenter>
        ),
      }),
    ),
  };
}

export function getAccessMethodFieldValidationSchema() {
  return {
    accessMethod: Yup.mixed<AccountAccessMethod>()
      .oneOf(Object.values(AccountAccessMethod))
      .required(t('fieldValidationMessages.required')),
  };
}
